import { render, staticRenderFns } from "./workRemarkList.vue?vue&type=template&id=49b91b92&scoped=true&"
import script from "./workRemarkList.vue?vue&type=script&lang=js&"
export * from "./workRemarkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b91b92",
  null
  
)

export default component.exports